import React, { useCallback, useEffect, useImperativeHandle, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { withRouter, useLocation, useHistory } from 'react-router-dom'
import { DigitalVaultHomeView } from '../../views'

function DigitalVaultHomeAction(props) {
  const { toggleErrorRequesting, viewAsCards, setViewAsCards, tabRef } = props

  const locationFromHook = useLocation()
  const { state, search } = locationFromHook
  const history = useHistory()
  const [companies, setCompanies] = useState([])
  const [selectedCompany, setSelectedCompany] = useState(null)
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [subcategoryPath, setSubcategoryPath] = useState([])
  const [subcategoryId, setSubcategoryId] = useState('')
  const [selectedDocument, setSelectedDocument] = useState(null)

  const [documentId, setDocumentId] = useState('')
  const [fileManagerPath, setFileManagerPath] = useState('/')
  const [breadcrumbItems, setBreadcrumbItems] = useState([])

  useEffect(() => {
    const params = new URLSearchParams(search)
    const documentIdParam = params.get('documentId')

    if (documentIdParam) {
      setDocumentId(documentIdParam)

      // Si hay state (viene del File Manager), restaurar también selectedCompany
      if (state) {
        if (state.companyId) {
          // Crear un objeto de empresa temporal con el ID
          setSelectedCompany({ company: { id: state.companyId } })
        }
        if (state.selectedCategory) {
          setSelectedCategory(state.selectedCategory)
        }
        if (state.breadcrumbItems) {
          setBreadcrumbItems(state.breadcrumbItems)
        }
        if (state.fileManagerPath) {
          setFileManagerPath(state.fileManagerPath)
        }
        if (state.subcategoryId) {
          setSubcategoryId(state.subcategoryId)
        }
        setSubcategoryPath(Array.isArray(state.subcategoryPath) ? state.subcategoryPath : [])
      }
    } else if (state) {
      if (state.companyId) {
        setSelectedCompany({ company: { id: state.companyId } })
      } else if (state.selectedCompany) {
        setSelectedCompany(state.selectedCompany)
      }
      setSelectedCategory(state.selectedCategory)
      setSubcategoryPath(Array.isArray(state.subcategoryPath) ? state.subcategoryPath : [])
      if (state.fileManagerPath) {
        setFileManagerPath(state.fileManagerPath)
      }
      if (state.subcategoryId) {
        setSubcategoryId(state.subcategoryId)
      }
      if (state.documentId) {
        setDocumentId(state.documentId)
      } else {
        setDocumentId('')
      }
      // Handle selectedDocument from tracking view
      if (state.selectedDocument && state.selectedDocument.documentId) {
        setSelectedDocument(state.selectedDocument)
      }
    } else {
      setFileManagerPath('/')
      setDocumentId('')
    }
  }, [state, search])

  function createFileManagerPath({ items }) {
    const newArr = items.splice(1)
    return `/${newArr.map((i) => i.id).join('/')}/`
  }

  const handleBreadcrumbClick = (event, item) => {
    event.preventDefault()
    if (item.id === 0) {
      setFileManagerPath('/')
      setDocumentId('')
    } else {
      const path = createFileManagerPath({
        items: breadcrumbItems
      })

      setFileManagerPath(path)
      setDocumentId('')
    }
  }

  function goBack() {
    const breadcrumbsCopy = [...breadcrumbItems]
    const path = createFileManagerPath({
      items: breadcrumbsCopy
    })

    const lastBreadcrumb = breadcrumbItems[breadcrumbItems.length - 1]
    const currentSubcategoryId = lastBreadcrumb?.id || ''

    setDocumentId('')

    history.push({
      pathname: '/digital-vault/home',
      search: '',
      state: {
        fileManagerPath: path,
        selectedCompany,
        selectedCategory,
        subcategoryPath,
        subcategoryId: currentSubcategoryId
      }
    })
  }

  const newDocument = useCallback(() => {
    const pathArr = Array.isArray(subcategoryPath) ? subcategoryPath : []
    const subPath = pathArr
      .map((i) => i?.subcategory?.id ?? i?.id ?? i)
      .filter((v) => v !== undefined && v !== null && v !== '')
      .join(',')

    return {
      companyId: selectedCompany?.company?.id,
      categoryId: selectedCategory?.id,
      subcategoryPath: subPath,
    }
  }, [subcategoryPath, selectedCategory, selectedCompany])

  const clearData = useCallback(() => {
    setSelectedCompany(null)
    setSelectedCategory(null)
    setSubcategoryPath([])
    setSelectedDocument(null)
  }, [])

  useImperativeHandle(tabRef, () => ({ newDocument, clearData }), [newDocument, clearData])

  return (
    <DigitalVaultHomeView
      {...props}
      location={locationFromHook}
      history={history}
      toggleErrorRequesting={toggleErrorRequesting}
      viewAsCards={viewAsCards}
      setViewAsCards={setViewAsCards}
      breadcrumbItems={breadcrumbItems}
      setBreadcrumbItems={setBreadcrumbItems}
      handleBreadcrumbClick={handleBreadcrumbClick}
      companies={companies}
      setCompanies={setCompanies}
      selectedCompany={selectedCompany}
      setSelectedCompany={setSelectedCompany}
      selectedCategory={selectedCategory}
      setSelectedCategory={setSelectedCategory}
      selectedDocument={selectedDocument}
      setSelectedDocument={setSelectedDocument}
      subcategoryPath={subcategoryPath}
      setSubcategoryPath={setSubcategoryPath}
      subcategoryId={subcategoryId}
      setSubcategoryId={setSubcategoryId}
      documentId={documentId}
      setDocumentId={setDocumentId}
      fileManagerPath={fileManagerPath}
      setFileManagerPath={setFileManagerPath}
      goBack={goBack}
    />
  )
}

export default withRouter(withTranslation()(DigitalVaultHomeAction))
